import { SearchType } from '@/generated/Enumerations/SearchType_pb'
import { TrackingSearchBy } from '@/generated/Enumerations/TrackingSearchBy_pb'
import { TrackingFiltersDto_ColumnSearching } from '@/generated/Messages/Filters_pb'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'

export const createTrackingSearching = (
    searchText: string
): OmitDeepMessageFields<TrackingFiltersDto_ColumnSearching>[] => [
    {
        searchBy: TrackingSearchBy.INTERNAL_DESCRIPTION,
        searchText,
        searchType: SearchType.CONTAINS,
    },
    {
        searchBy: TrackingSearchBy.PUBLIC_DESCRIPTION,
        searchText,
        searchType: SearchType.CONTAINS,
    },
    {
        searchBy: TrackingSearchBy.PROJECT_NAME,
        searchText,
        searchType: SearchType.CONTAINS,
    },
]
